import { render } from "./ReferenceLab.vue?vue&type=template&id=53129e84"
import script from "./ReferenceLab.vue?vue&type=script&lang=js"
export * from "./ReferenceLab.vue?vue&type=script&lang=js"

import "./ReferenceLab.vue?vue&type=style&index=0&id=53129e84&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/ReferenceLab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53129e84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53129e84', __exports__)) {
    console.log('reload')
    api.reload('53129e84', __exports__)
  }
  
  module.hot.accept("./ReferenceLab.vue?vue&type=template&id=53129e84", () => {
    console.log('re-render')
    api.rerender('53129e84', render)
  })

}


export default __exports__